import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ Global Unhandled Promise Rejection Handler
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  
  // Timeout hatalarını sessizce handle et (site çökmesin)
  if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
    console.warn('⚠️ Timeout hatası yakalandı:', error);
    event.preventDefault(); // Promise rejection'ı handle ettik, default davranışı engelle
    return;
  }
  
  // Network hatalarını sessizce handle et
  if (error?.code === 'ERR_NETWORK' || error?.message?.includes('Network Error')) {
    console.warn('⚠️ Network hatası yakalandı:', error);
    event.preventDefault();
    return;
  }
  
  // HTTP hatalarını (409, 500, 400, vb.) sessizce handle et
  if (error?.response?.status || error?.code === 'ERR_BAD_RESPONSE') {
    const status = error?.response?.status || 'unknown';
    if (status === 409) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    console.warn(`⚠️ HTTP ${status} hatası yakalandı:`, error?.response?.data || error?.message);
    event.preventDefault();
    event.stopPropagation();
    return;
  }
  
  // Axios hatalarını genel olarak handle et
  if (error?.isAxiosError || error?.name === 'AxiosError') {
    console.warn('⚠️ Axios hatası yakalandı:', error?.message || error);
    event.preventDefault();
    event.stopPropagation();
    return;
  }
  
  // Redux Toolkit unwrap() hatalarını handle et
  // unwrap() kullanıldığında rejectWithValue ile dönen string hatalar
  if (typeof error === 'string' && (
    error.includes('silinemez') || 
    error.includes('güncellenemedi') || 
    error.includes('oluşturulamadı') ||
    error.includes('gönderilemedi')
  )) {
    console.warn('⚠️ Redux thunk hatası yakalandı:', error);
    event.preventDefault();
    event.stopPropagation();
    return;
  }
  
  // Diğer hatalar için logla ama site çökmesin
  console.error('⚠️ Unhandled Promise Rejection:', error);
  event.preventDefault();
});

// ✅ Global Error Handler (senkron hatalar için)
window.addEventListener('error', (event) => {
  console.error('⚠️ Global Error:', event.error);
  // Site çökmesin, sadece logla
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
reportWebVitals();
